export function isMobileDevice() {
  if (typeof navigator === 'undefined') return false;
  return /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent);
}

/** Open WhatsApp — mobile uses same-tab navigation (reliable); desktop opens a new tab. */
export function openWhatsApp(url) {
  if (!url) return;
  if (isMobileDevice()) {
    window.location.assign(url);
    return;
  }
  const opened = window.open(url, '_blank', 'noopener,noreferrer');
  if (!opened) window.location.assign(url);
}
